var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.entity
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new": false,
              "show-delete": _vm.entity.isActive && !_vm.entity.isNew,
              "show-print": !_vm.entity.isNew,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c(
                  "app-side-menu",
                  { attrs: { "min-width": 18, "fixed-menu": false } },
                  [
                    _c(
                      "aside",
                      {
                        staticClass: "menu",
                        attrs: { slot: "side-menu" },
                        slot: "side-menu",
                      },
                      [
                        _c("p", { staticClass: "menu-label" }, [
                          _c("span", { staticClass: "title is-6" }, [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.entity.rego ? _vm.entity.rego : "Rego"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c("ul", { staticClass: "menu-list" }, [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: _vm.routeTypes.VehicleDetail.name,
                                      query: _vm.$route.query,
                                    },
                                    "active-class": "is-active",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "has-badge-danger has-badge-small has-badge-rounded has-badge-offset2":
                                          _vm.$v.$invalid,
                                      },
                                      attrs: {
                                        "data-badge": _vm.$v.$invalid
                                          ? ""
                                          : null,
                                      },
                                    },
                                    [_vm._v(" Detail Info ")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("router-view", {
                  attrs: { entity: _vm.entity },
                  on: { toggleActive: _vm.onToggleActive },
                }),
              ],
              1
            ),
          ]),
          _c(
            "unsaved-modal",
            {
              attrs: { active: _vm.isUnsavedModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isUnsavedModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                skipSave: function ($event) {
                  return _vm.skipSave()
                },
                saveContinue: function ($event) {
                  return _vm.saveContinue()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Unsaved Changes"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "There are unsaved changes. Please select action below"
                  ),
                ]
              ),
            ]
          ),
          _c(
            "save-conflict-modal",
            {
              attrs: { active: _vm.isSaveConflictModalActive },
              on: {
                "update:active": function ($event) {
                  _vm.isSaveConflictModalActive = $event
                },
                close: function ($event) {
                  return _vm.closeModal()
                },
                reload: function ($event) {
                  return _vm.reloadData()
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Change conflict"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _vm._v(
                    "The data on the server is newer than the local copy. Please reload local data."
                  ),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isConfirmModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isConfirmModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true, true)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Vehicle is in use"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.entity.rego))]
                  ),
                  _vm._v(" is in use. Set to "),
                  _c("span", { staticClass: "tag is-danger" }, [
                    _vm._v("In-Active"),
                  ]),
                  _vm._v(" anyway? "),
                ]
              ),
            ]
          ),
          _c(
            "confirm-modal",
            {
              attrs: {
                active: _vm.isToggleModalActive,
                "ok-text": "Yes",
                "cancel-text": "No",
              },
              on: {
                "update:active": function ($event) {
                  _vm.isToggleModalActive = $event
                },
                ok: function ($event) {
                  return _vm.deleteEntity(true, false)
                },
                cancel: function ($event) {
                  return _vm.deleteEntity(false)
                },
              },
            },
            [
              _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                _vm._v("Vehicle is in use"),
              ]),
              _c(
                "p",
                { attrs: { slot: "text-content" }, slot: "text-content" },
                [
                  _c(
                    "span",
                    { staticClass: "has-text-primary has-text-weight-bold" },
                    [_vm._v(_vm._s(_vm.entity.rego))]
                  ),
                  _vm._v(" is in use. Set to "),
                  _c("span", { staticClass: "tag is-danger" }, [
                    _vm._v("In-Active"),
                  ]),
                  _vm._v(" anyway? "),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }